import { render, staticRenderFns } from "./sharia_quran.vue?vue&type=template&id=12f6be8f"
import script from "./sharia_quran.vue?vue&type=script&lang=js"
export * from "./sharia_quran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports